type BenefitType = 'coupon' | 'checkout' | 'point' | 'discount' | 'zpay_discount';

export type Benefit = Record<BenefitType, boolean>;

export const getBenefitType = (props: Benefit) => {
  const arr: string[] = [];

  for (const key in props) {
    if (props[key as BenefitType]) {
      arr.push(key);
    }
  }

  return arr.toString();
};
